var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-field"},[_c('label',{staticClass:"subtitle is-7",attrs:{"for":"field"}},[_vm._v(_vm._s(_vm.$t(_vm.pLabel)))]),_c('h6',{staticClass:"has-text-grey-dark is-6"},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.pValue)+" ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }